import * as uuid from 'uuid'

import LegacyCRS from './LegacyCRS'
import WanderCRS from './WanderCRS'
import { APIClient } from '../io/api-client'
import {
  EventHub,
  EventHubKeepAlive,
  EventHubReconnector
} from '../io/event-hub'

export default class ClientSession {
  readonly id: string
  readonly apiClient: APIClient
  readonly eventHub: EventHub
  readonly eventHubReconnector: EventHubReconnector
  readonly eventHubKeepAlive: EventHubKeepAlive
  readonly wanderCRS: WanderCRS
  readonly legacyCRS: LegacyCRS

  constructor (
    options: {
      apiClient: APIClient
      eventHub: EventHub
      eventHubReconnector: EventHubReconnector
      eventHubKeepAlive: EventHubKeepAlive
      wanderCRS: WanderCRS
      legacyCRS: LegacyCRS
    },
    id: string = uuid()
  ) {
    this.apiClient = options.apiClient
    this.eventHub = options.eventHub
    this.eventHubReconnector = options.eventHubReconnector
    this.eventHubKeepAlive = options.eventHubKeepAlive
    this.wanderCRS = options.wanderCRS
    this.legacyCRS = options.legacyCRS
    this.id = id
    this.apiClient.sessionID = id
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/ClientSession.ts